import { createSelector } from "reselect";

import { apiPageLimits } from "src/constants";

// Utils
import { buildQueryString } from "src/utils/build_query_string";

/**
 * create a selector to get the api query for admin facility floors
 * @returns {function} selector
 */
export function createAdminFloorsQuerySelector() {
  return createSelector(
    () => {
      return apiPageLimits.adminFacilityFloors;
    },
    pageLimit => {
      const query = {
        page: { limit: pageLimit }
      };
      return buildQueryString(query);
    }
  );
}
